(function ($) {
    $(document).ready(function() {
        if ($('.container').hasClass('has-sidebar')) {
            $('.image-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                arrows: true,
                centerPadding: '0px',
                dots: true
            });
        } else {
            $('.image-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                arrows: true,
                centerPadding: '100px',
                dots: true,

                responsive: [

                    {
                      breakpoint: 768,
                      settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '0px',
                        slidesToShow: 1
                      }
                    }
                ]
            });
        }


    });
}(jQuery));